// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2p0wU","fullView":"styles_fullView__2-36s"};